import React from 'react'

import clsx from 'clsx'

import classes from './LinearProgress.module.scss'

/** @type {import("./types").default} */
const LinearProgress = ({ className, value = 0, color = 'teal' }) => (
  <div className={clsx('LinearProgress', classes.root, className)}>
    <div className={clsx(classes.bar, classes[color])} style={{ transform: `translateX(${-(100 - value)}%)` }} />
  </div>
)

export default LinearProgress
